import {
    Constraint,
    MaxLengthConstraint,
    MinLengthConstraint,
    RegExpConstraint,
    RequiredConstraint
} from "./constraints";

export const PasswordValidationConstraints = (): Constraint[] => {
    return [
        RequiredConstraint(),
        MaxLengthConstraint(60),
        MinLengthConstraint(8),
        RegExpConstraint(/\p{Ll}/u, 'global.password.missing_letter'),
        RegExpConstraint(/\d+/g, 'global.password.missing_number'),
        RegExpConstraint(/(\p{Ll}+.*\p{Lu})|(\p{Lu}+.*\p{Ll})/u, 'global.password.missing_case_dif'),
        RegExpConstraint(/[^p{Ll}\p{Lu}\p{Ll}\p{N}]/u, 'global.password.missing_special_char'),
    ]
}